angular.module('app.entity.audit')
    .filter('labelBoolean', ['gettext', function(gettext){
        return function(value){
            return value === 'true' || !! value ? gettext('Verdadero') : gettext('Falso');
        };
    }]);
